module.exports = __webpack_public_path__ + "img/icon-school4.54c8d6b3.png";